<template>
  <div class="agencyManage">
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="small"
        label-width="110px"
        :model="formInline"
        inline
      >
        <el-form-item prop="name" label-width="90" label="代理商名称">
          <el-input
            clearable
            v-model.trim="formInline.name"
            placeholder="请输入代理商名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="contactsName" label="联系人名称">
          <el-input
            clearable
            v-model.trim="formInline.contactsName"
            placeholder="请输入联系人名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="contactsPhone" label="联系人手机号">
          <el-input
            v-model.trim="formInline.contactsPhone"
            maxlength="11"
            placeholder="请输入联系人手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-left: 30px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <div class="title">
        <el-button
          size="small"
          type="primary"
          @click="openHandleAgency('agency_add')"
        >新增代理商</el-button>
        <el-button size="small" type="primary" @click="openMenuAdmin">代理商菜单管理</el-button>
        <el-button size="small" type="primary" @click="openRolesProfile">代理商角色配置</el-button>
      </div>
      <el-table border v-loading="loading" :data="data" style="width: 100%">
        <el-table-column label="代理商名称" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="代理商logo" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <div v-if="row.logo">
              <el-image
                style="width: 60px; height: 60px"
                :src="row.logo"
                :preview-src-list="[row.logo]"
              />
            </div>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人姓名" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contactsName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="联系人手机号" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.contactsPhone || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合约名称" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.splitContractName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合作状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <template v-if="row.contractValidityStatus === 1">
              <el-tag v-if="row.cooperateState === 1">合作中</el-tag>
              <el-tag type="success" v-else-if="row.cooperateState === 2">合作暂停</el-tag>
            </template>
            <el-tag type="danger" v-else>合作合同待上传</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="当前合同状态" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.contractValidityStatus === 1">有效期内</el-tag>
            <el-tag type="danger" v-else-if="row.contractValidityStatus === 2">不在有效期内</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.lastUpdateDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="最后操作人" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.lastUpdateName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="300"
          fixed="right"
          align="center"
          label="操作"
        >
          <template slot-scope="{ row }">
            <div>
              <span
                :class="row.contractValidityStatus === 1 ? 'blue_Box' : 'gray_Box'"
                v-if="row.cooperateState === 1"
                @click="handleConsociation('2', row)"
              >暂停合作</span>
              <span
                :class="row.contractValidityStatus === 1 ? 'blue_Box' : 'gray_Box'"
                v-else
                @click="handleConsociation('1', row)"
              >继续合作</span>
              <span
                class="blue_Box"
                @click="openHandleAgency('agency_alter', row)"
              >编辑</span>
              <span
                class="blue_Box"
                @click="openHandleSignInfo(row)"
              >签约信息</span>
              <span class="blue_Box" @click="openSetAdmin(row)">设置管理员</span>
            </div>
            <div>
              <span class="blue_Box" @click="openContractAdmin(row)">合同管理</span>
              <span class="blue_Box" @click="openBindingContract(row)">绑定分账合约</span>
              <span class="blue_Box" @click="openBillRatioSetting(row)">分账比例配置</span>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <!-- 添加、编辑代理商 -->
    <HandleAgency ref="handleAgencyRef" />
    <!-- 代理商角色配置 -->
    <RolesProfile ref="rolesProfileRef" />
    <!-- 合同管理 -->
    <ContractAdmin ref="contractAdminRef" />
    <!-- 签约信息 -->
    <SignInfo ref="signInfoRef" />
    <!-- 设置管理员 -->
    <SetAdmin ref="setAdminRef" />
    <!-- 绑定分账合约 -->
    <BindingContract ref="bindingContractRef" @refresh="refresh" />
    <!-- 分账比例设置 -->
    <BillRatioSetting ref="billRatioSettingRef" :type="1" @refresh="refresh" />
    <!-- 菜单管理 -->
    <MenuAdmin ref="menuAdminRef" title="代理商菜单管理" />
  </div>
</template>

<script>
import { getProxyList, updateCompany } from "@/api/organization";
import MenuAdmin from "@/views/organization/components/menuAdmin.vue";
import HandleAgency from "@/views/organization/components/handleAgency.vue";
import SetAdmin from "@/views/organization/components/setAdmin.vue";
import BindingContract from "@/views/organization/components/bindingContract.vue";
import BillRatioSetting from "@/views/organization/components/billRatioSetting.vue";
import RolesProfile from "@/views/organization/components/rolesProfile.vue";
import ContractAdmin from "@/views/organization/components/contractAdmin.vue";
import SignInfo from "@/views/organization/components/signInfo.vue";
import myPagination from "@/components/myPagination.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  name: "AgencyManage",
  components: {
    myPagination,
    HandleAgency,
    RolesProfile,
    ContractAdmin,
    SignInfo,
    SetAdmin,
    BindingContract,
    BillRatioSetting,
    MenuAdmin,
  },
  data() {
    return {
      loading: false,
      formInline: {
        name: "",
        contactsName: "",
        contactsPhone: "",
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
    };
  },
  mounted() {
    this.getProxyList({ page: 1, limit: 10 });
  },
  methods: {
    // 设置管理员
    openSetAdmin(payload) {
      this.$refs.setAdminRef.init(payload.id);
    },
    // 合同管理
    openContractAdmin(payload) {
      this.$refs.contractAdminRef.init(payload.id);
    },
    // 绑定分账合约
    openBindingContract(payload) {
      this.$refs.bindingContractRef.init(payload.id);
    },
    // 分账比例设置
    openBillRatioSetting(payload) {
      this.$refs.billRatioSettingRef.init(payload);
    },
    // 刷新
    refresh() {
      this.getProxyList(
        Object.assign(this.searchData, {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 继续、暂停合作
    handleConsociation(
      cooperateState,
      { id, name, logo, contractValidityStatus }
    ) {
      if (contractValidityStatus !== 1) {
        return;
      }
      let message = cooperateState === "1" ? "继续" : "暂停";
      this.$confirm(`您确认要${message}合作吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateCompany({ cooperateState, id, name, logo }).then((res) => {
          if (res.code === 0) {
            this.refresh();
            this.$message({
              type: "success",
              message: `合作已${message}`,
            });
          }
        });
      });
    },
    async getProxyList(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getProxyList({ ...payload });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    openMenuAdmin() {
      this.$refs.menuAdminRef.init("agency");
    },
    openRolesProfile() {
      this.$refs.rolesProfileRef.init("agency");
    },
    // 添加、编辑
    openHandleAgency(status, payload) {
      this.$refs.handleAgencyRef.init(status, payload);
    },
    // 添加、编辑签约信息
    openHandleSignInfo(payload) {
      this.$refs.signInfoRef.init(payload.id);
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getProxyList(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.getProxyList({ page: 1, limit: 10 });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getProxyList(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getProxyList(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.agencyManage {
  .title {
    margin: 0px 0 10px;
  }

  .gray_Box {
    display: inline-block;
    padding: 0 6px;
    margin: 2px;
    text-align: left;
    color: gray;
    cursor: not-allowed;
  }

  .blue_Box {
    display: inline-block;
    padding: 0 6px;
    margin: 2px;
    text-align: left;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }

  ::v-deep .action_box .cell {
    padding: 0 0 0 20px;
  }
}
</style>
